export default [
    {
        comment: '',
        error_id: 'FL-WSEL-01',
        data: [
            {cross_section: '4420', profile: 'FW', side: 'left'},
            {cross_section: '4550', profile: 'FW', side: 'left'},
            {cross_section: '4650', profile: 'FW', side: 'right'},
            {cross_section: '4750', profile: 'FW', side: 'left'},
            {cross_section: '4850', profile: 'FW', side: 'left'},
            {cross_section: '4950', profile: 'FW', side: 'right'},
            {cross_section: '5505', profile: '100yr (1%)', side: 'right'},
            {cross_section: '5605', profile: '100yr (1%)', side: 'right'},
            {cross_section: '5705', profile: '100yr (1%)', side: 'left'},
            {cross_section: '5805', profile: '100yr (1%)', side: 'right'},
            {cross_section: '5905', profile: '100yr (1%)', side: 'left'},
            {cross_section: '6005', profile: '100yr (1%)', side: 'right'},
        ]
    },
]